import React from 'react';

import AuthUserContext from './context';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';


const withAuthentication = Component => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        authUser: JSON.parse(localStorage.getItem('authUser')),
        readyToRedirect: false
      };
    }

    componentDidMount() {
      if(!this.state.authUser) {
       this.setState({readyToRedirect: true });
      }
      this.listener = this.props.firebase.onAuthUserListener(
        authUser => {
          localStorage.setItem('authUser', JSON.stringify(authUser));
          this.setState({ authUser });
        },
        () => {
          localStorage.removeItem('authUser');
          this.setState({ authUser: null });
        },
        this.props
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      if (this.state.readyToRedirect && window.location.pathname === '/' && !this.state.authUser) {
        window.location.href = 'signin';
      } else if( (window.location.pathname === '/' && this.state.authUser) 
              || (this.state.authUser && window.location.pathname === '/signin')
              || (this.state.authUser && window.location.pathname === '/signout')  ) {
        window.location.href = ROUTES.AVAILABILITY;
      }
      return (
        <AuthUserContext.Provider value={this.state.authUser}>
          <Component {...this.props} />
        </AuthUserContext.Provider>
      );
    }
  }

  return withFirebase(WithAuthentication);
};

export default withAuthentication;
